package org.beatonma.orbitals.core

actual val platform: Platform = Platform.Web
